import { TagColor } from '../types';

/** Gets the TagColor enum value from a hex string */
export const getTagColorFromHex = (hex?: string): TagColor | undefined => {
  if (!hex) return undefined;
  return Object.entries(TagColor).find(([_, value]) => value.toLowerCase() === hex.toLowerCase())?.[1];
};
